<div class="wrapper wrapper-full-page">
    <div class="page-header login-page" filter-color="black" style="background-image: url('./assets/img/fondosjpg/fondo.png'); background-size: cover; background-position: top center;">
   
  
      <div class="container">
            <div   class="card2 card-login card-hidden" style="width: 260px;border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) calc(0.25rem - 1px) calc(0.25rem - 1px);padding: 0.75rem 1.25rem;margin-bottom: 0;">
                <a>
                    <img class="img"  width="220" src="./assets/img/logohorizontalpng/logo1.png" aria-label="Solser">
                </a>
            </div>  
  
        <div class="row">
          
  
          <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
            <form [formGroup]="formRegistro" (ngSubmit)="onSignin(f)" #f="ngForm">
              <div class="card card-login card-hidden">
                <div class="card-header card-header-info text-center">
                  <h4 class="card-title">Recupera tu contraseña</h4>
  
                </div>
                <div class="card-body ">
               
                  <span class="bmd-form-group">
                  </span>
                
                  <span class="bmd-form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons">lock_outline</i>
                        </span>
                      </div>
                      <input notCopyPaste type="password" formControlName="password" ngModel class="form-control" placeholder="Nueva contraseña" aria-label="Nueva contraseña" maxlength="15">
                    </div>         
                    <mat-error>
                      <div *ngIf="formRegistro.controls.password.invalid && 
                            (formRegistro.controls.password.dirty || formRegistro.controls.password.touched)" >
                        <strong 
                        style="color: #b71c1c; font-size: 12px; padding: auto; margin-right: 16px; margin-left: 20px;">* Campo requerido</strong>
                      </div>
                      </mat-error>           
                  </span>

                  <span class="bmd-form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons">lock</i>
                        </span>
                      </div>
                      <input notCopyPaste type="password" formControlName="confirmPassword" ngModel class="form-control" placeholder="Confirmar tu nueva contraseña" aria-label="Confirmar tu nueva contraseña" maxlength="20">
                    </div>
                    <mat-error *ngIf="formRegistro.controls.confirmPassword.dirty&&formRegistro.controls.confirmPassword.errors">                                                                
                        <strong style="color: #b71c1c; font-size: 12px; padding: auto; margin-right: 16px; margin-left: 20px;">* No coincide con la contraseña</strong>
                    </mat-error>
                  </span>

                </div>
                
                
                <div class="card-footer justify-content-center">
                  <button class="btn btn-info  btn-lg" type="submit" [disabled]="!f.valid">Actualizar contraseña</button>
                </div>             
              </div>
            </form>


              



          </div>
        </div>
      </div>

      <footer class="footer  ">
        <div class="container ">
  
          <div class="copyright pull-right " >
            <span class="text-muted"> {{ dateTime | date : 'long'  }}</span>,              
            <a  class="text-muted">Solser Sistem S.A. de C.V.</a> 
          </div>
        </div>
      </footer>

    </div>
  </div>
  